import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Paper, FormControl, InputLabel, Select, MenuItem, FormControlLabel, RadioGroup, Radio, useTheme } from '@mui/material';
// import { Header } from '../components/Header'; // REMOVED
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import mockTopics from '../data/mockChats.json'; 

export const CreateChat = () => {
    const theme = useTheme();
    const [roomDetails, setRoomDetails] = useState({
        title: '',
        description: '',
        topic: '',
        visibility: 'public',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRoomDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitting new room:", roomDetails);
        alert(`Attempting to create room: ${roomDetails.title}`);
    };

    return (
        // REMOVED: <Header />
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <AddCircleOutlineIcon color="secondary" sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
                        Create a New Chat Room
                    </Typography>
                    <Typography color="text.secondary">
                        Start a space for your community to connect and share.
                    </Typography>
                </Box>

                <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    
                    {/* Room Title */}
                    <TextField
                        required
                        fullWidth
                        label="Room Title"
                        name="title"
                        value={roomDetails.title}
                        onChange={handleChange}
                        variant="outlined"
                    />

                    {/* Description */}
                    <TextField
                        required
                        fullWidth
                        label="Short Description (What is this room about?)"
                        name="description"
                        value={roomDetails.description}
                        onChange={handleChange}
                        multiline
                        rows={3}
                        variant="outlined"
                    />

                    {/* Choose Topic */}
                    <FormControl fullWidth required>
                        <InputLabel id="topic-label">Choose Topic</InputLabel>
                        <Select
                            labelId="topic-label"
                            label="Choose Topic"
                            name="topic"
                            value={roomDetails.topic}
                            onChange={handleChange}
                        >
                            {mockTopics.map((topic) => (
                                <MenuItem key={topic.id} value={topic.name}>
                                    {topic.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Visibility */}
                    <FormControl component="fieldset">
                        <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                            Visibility
                        </Typography>
                        <RadioGroup
                            row
                            name="visibility"
                            value={roomDetails.visibility}
                            onChange={handleChange}
                        >
                            <FormControlLabel 
                                value="public" 
                                control={<Radio color="primary" />} 
                                label="Public (Anyone can join)" 
                            />
                            <FormControlLabel 
                                value="private" 
                                control={<Radio color="primary" />} 
                                label="Private (Invitation only - optional later)" 
                            />
                        </RadioGroup>
                    </FormControl>

                    {/* Create Button */}
                    <Button 
                        type="submit" 
                        variant="contained" 
                        color="secondary" 
                        size="large"
                        sx={{ mt: 2, py: 1.5 }}
                    >
                        Create Room
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};